<template>
  <div class="detailBox" style="position: relative">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        :rules="rules"
        inline
      >
        <ul style="display: flex">
          <el-form-item
            label="状态/类型"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择客户状态', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <div style="display: flex; align-items: center">
              <el-switch v-model="state.model.IsQy" />
              <el-radio-group
                v-model="state.model.Lx"
                style="margin-left: 30px"
              >
                <el-radio :label="1">个人客户</el-radio>
                <el-radio :label="2">单位客户</el-radio>
                <el-radio :label="3">同行客户</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item
            label="客户经理"
            prop="JlId"
            :rules="[
              { required: true, message: '请选择客户经理', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <div style="display: flex; width: 100%; overflow: hidden">
              <el-input
                v-model="state.model.JlXm"
                class="shade"
                style="margin-right: 10px"
                readonly
              ></el-input>
              <el-button type="warning" @click="state.showUser = true">
                选择
              </el-button>
            </div>
          </el-form-item>
        </ul>
        <template v-if="state.model.Lx == 1">
          <ul style="display: flex">
            <el-form-item
              label="姓名"
              prop="Mc"
              :rules="[
                { required: true, message: '请输入客户姓名', trigger: 'blur' },
              ]"
              style="flex: 1"
            >
              <el-input v-model="state.model.Mc"></el-input>
            </el-form-item>
            <el-form-item label="性别" style="flex: 1">
              <el-radio-group v-model="state.model.Xb">
                <el-radio :label="1" style="color: #1779de"> 男 </el-radio>
                <el-radio :label="2" style="color: #f00"> 女 </el-radio>
              </el-radio-group>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item label="手机号码" style="flex: 1">
              <el-input v-model="state.model.Sjhm"></el-input>
            </el-form-item>
            <el-form-item label="出生日期" style="flex: 1">
              <el-date-picker
                v-model="state.model.Sr"
                type="date"
                placeholder="--出生日期--"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                :disabled-date="
                  (data) => {
                    return $dayjs(data) > $dayjs();
                  }
                "
              />
            </el-form-item>
          </ul>
        </template>
        <template v-else>
          <ul style="display: flex">
            <el-form-item
              label="单位名称"
              prop="Mc"
              :rules="[
                { required: true, message: '请输入单位名称', trigger: 'blur' },
              ]"
              style="flex: 1"
            >
              <el-input v-model="state.model.Mc"></el-input>
            </el-form-item>
            <el-form-item label="单位简称" style="flex: 1">
              <el-input v-model="state.model.Jc"></el-input>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item label="联系人" style="flex: 1">
              <el-input v-model="state.model.Lxr"></el-input>
            </el-form-item>
            <el-form-item label="性别" style="flex: 1">
              <el-radio-group v-model="state.model.Xb">
                <el-radio :label="1" style="color: #1779de"> 男 </el-radio>
                <el-radio :label="2" style="color: #f00"> 女 </el-radio>
              </el-radio-group>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item label="手机号码" style="flex: 1">
              <el-input v-model="state.model.Sjhm"></el-input>
            </el-form-item>
            <el-form-item label="出生日期" style="flex: 1">
              <el-date-picker
                v-model="state.model.Sr"
                type="date"
                placeholder="--出生日期--"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                :disabled-date="
                  (data) => {
                    return $dayjs(data) > $dayjs();
                  }
                "
              />
            </el-form-item>
          </ul>
        </template>
        <ul style="display: flex">
          <el-form-item label="来源" style="flex: 1">
            <el-select v-model="state.model.Ly" :clearable="false">
              <el-option label="网络" :value="1" />
              <el-option label="现场" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="职务" style="flex: 1">
            <el-input v-model="state.model.Zw"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="QQ账号" style="flex: 1">
            <el-input v-model="state.model.QQ"></el-input>
          </el-form-item>
          <el-form-item label="微信账号" style="flex: 1">
            <el-input v-model="state.model.Wx"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="微博账号" style="flex: 1">
            <el-input v-model="state.model.Wb"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" style="flex: 1">
            <el-input v-model="state.model.Yx"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="现住地址" style="flex: 1">
            <el-input v-model="state.model.Dz"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="所属板块" style="flex: 1">
            <el-select
              v-model="state.model.BkId"
              placeholder="--请选择所属板块--"
              :filter-method="onBkFilter"
            >
              <el-option
                v-for="item in state.bkData || []"
                :key="item.Id"
                :label="item.Mc"
                :value="item.Id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadBk()"> 刷新 </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="所属行业" style="flex: 1">
            <el-select
              v-model="state.model.Hy"
              placeholder="--请选择所属板块--"
              :filter-method="onHyFilter"
            >
              <el-option
                v-for="item in state.hyData || []"
                :key="item.Mc"
                :label="item.Mc"
                :value="item.Mc"
              />
              <template #footer>
                <el-button size="small" @click="onLoadHy()"> 刷新 </el-button>
              </template>
            </el-select>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="备注说明" style="flex: 1">
            <el-input
              type="textarea"
              v-model="state.model.Bz"
              :autosize="{ minRows: 4 }"
            />
          </el-form-item>
        </ul>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showUser"
        title="选择客户经理"
        @close="state.showUser = false"
      >
        <c_KeHuSelectUser @close="onUserClose" :id="state.model.JlId">
        </c_KeHuSelectUser>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { kehu_add, zidian_select } from "@/http/api";
import { ElMessage } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);

    const state = reactive({
      model: {
        IsQy: true,
        Xb: 1,
        Lx: 1,
        Ly: 1,
      },
    });
    onMounted(() => {
      onLoadBk();
      onLoadHy();
    });

    //加载板块下拉数据
    const onLoadBk = () => {
      zidian_select("板块").then((res) => {
        if (res.status == 200) {
          state.bkData = res.data;
          state.bkSource = res.data;
        }
      });
    };

    //加载行业下拉数据
    const onLoadHy = () => {
      zidian_select("行业").then((res) => {
        if (res.status == 200) {
          state.hyData = res.data;
          state.hySource = res.data;
        }
      });
    };

    //下拉框自定义筛选
    const onBkFilter = (query) => {
      state.bkData = state.bkSource.filter(
        (w) =>
          w.Py?.toUpperCase().includes(query.toUpperCase()) ||
          w.Sp?.toUpperCase().includes(query.toUpperCase()) ||
          w.Mc?.includes(query.toUpperCase())
      );
    };

    //下拉框自定义筛选
    const onHyFilter = (query) => {
      state.hyData = state.hySource.filter(
        (w) =>
          w.Py?.toUpperCase().includes(query.toUpperCase()) ||
          w.Sp?.toUpperCase().includes(query.toUpperCase()) ||
          w.Mc?.includes(query.toUpperCase())
      );
    };

    const onUserClose = (row) => {
      console.log(row);
      state.model.JlId = row.Id;
      state.model.JlXm = row.Xm;
      state.showUser = false;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          kehu_add(state.model).then((res) => {
            ElMessage.success("添加成功");
            if (res.status == 200) {
              setTimeout(() => {
                emit("close", res.data);
              }, 500);
            }
          });
        }
      });
    };

    return {
      state,
      onSubmit,
      props,
      formDom,
      onLoadBk,
      onLoadHy,
      onBkFilter,
      onHyFilter,
      onUserClose,
    };
  },
};
</script>
<style scoped></style>
